import { render, staticRenderFns } from "./EditAnnouncement.vue?vue&type=template&id=5aa98746&scoped=true&"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js&"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnouncement.vue?vue&type=style&index=0&id=5aa98746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa98746",
  null
  
)

export default component.exports